import fetchPhraseIfNeeded from 'helpers/utils/fetch-phrase-if-needed';

export const initInspirationsRemoved = () =>
    window.ikea.pubsub.subscribe('LIST_AGENT/UNAVAILABLE_INSPIRATIONS_REMOVED', async () => {
        await Promise.all([import('./bootInspirationsRemoved'), fetchPhraseIfNeeded()]).then(([{ boot }]) => {
            boot();
        });
    });
